// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../nuxt-app/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-enter-active[data-v-20c00c72],.dropdown-leave-active[data-v-20c00c72]{transition:opacity .2s,transform .2s cubic-bezier(0.2, 0.8, 0.2, 0.8)}.dropdown-enter[data-v-20c00c72],.dropdown-leave-to[data-v-20c00c72]{opacity:0;transform:translateY(1rem)}.dropdown-enter-to[data-v-20c00c72],.dropdown-leave[data-v-20c00c72]{opacity:1;transform:translateY(0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
